<template>
  <div class="app-container">
    <list ref="list" @change="onChange" @reload="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
          <el-button
          size="mini"
          type="primary"
          @click="create"
          icon="el-icon-plus"
          >添加</el-button
        >
        <!-- <el-button
          size="mini"
          class="filter-item"
          type="danger"
          @click="delRows"
          >删除</el-button
        > -->
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" v-if="row.Status==2" @click="detailsById(row.DocId)">查看</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="editById(row.DocId)">编辑</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="check(row)">审核</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="delRows(row.DocId)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
     <div class="list-head" style="margin-top: 10px;">
      <span>单据信息</span>
    </div>
    <el-table class="tb-c-head" :data="Details" v-loading="isLoading" border  show-summary  :summary-method="getSummaries">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column label="商品名称" prop="GoodsName"/>
         <el-table-column prop="Model" label="规格型号">
        <template slot-scope="{ row }">
          <span>{{row.Model}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitName" label="单位">
        <template slot-scope="{ row }">
          <span>{{row.UnitName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="数量"/>
      <el-table-column prop="OutCost" label="调出单价"/>
      <el-table-column prop="OutAmount" label="调出金额">
        <template slot-scope="{ row }">
          <span>{{row.OutAmount}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="InCost" label="调入单价" v-if="AllotType==1"/>
      <el-table-column prop="InAmount" label="调入金额" v-if="AllotType==1">
        <template slot-scope="{ row }">
          <span>{{row.InAmount}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ExistQuantity" label="可用数量">
        <template slot-scope="{ row }">
          <span>{{row.ExistQuantity}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注" />
    </el-table>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/stock/bismanage/allocation/list";
import editDialog from "@/components/stock/bismanage/allocation/editDialog";
import detailsDialog from "@/components/stock/bismanage/allocation/detailsDialog";

export default {
  name: "comment",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    detailsDialog
  },
  data() {
    return {
      api: require("@/api/stock/allotDoc").default,
      AllotType: 0,
      Details: [],
      isLoading: false,
    }
  },
  methods: {
       reload() {
      this.$refs.list.reload();
      this.Details = [];
    },
    onChange(row) {
      
      this.Details = [];
      this.isLoading = true;
      this.api.info(row.DocId).then((res) => {
        this.isLoading = false;
        if (res.Data){
          this.AllotType=res.Data.AllotType
          this.Details = res.Data.Goods;
        }
       
      });
    },
    getSummaries(param) {
      
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 4 || index === 6) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Math.floor( (prev + curr)*100 )/100;
              } else {
                return Math.floor(prev*100)/100;
              }
            }, 0);
            sums[index] = sums[index];
          }
          return;
        }
      });
      return sums;
    },
    check(row) {
      sessionStorage.setItem('check','1')
      this.$refs.detailsDialog.openEditById(row.DocId);
    },
    detailsById(id){
        this.$refs.detailsDialog.openDetailsById(id);
    },
    delRows(id) {
    this.$confirm("确认删除数据吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.api.delete(id).then(res => {
          if(res.Code ==0) {
            this.$message.success("删除成功")
            this.$refs.list.reload();
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
      .catch(() => {});
    },
  },
};
</script>